import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { MatrixRain } from './MatrixRain';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-matrix-black px-4 pt-20 pb-10" data-id="element-112">
      <MatrixRain data-id="element-113" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-114">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-cinzel text-5xl md:text-7xl font-bold text-matrix-cream mb-6 drop-shadow-[0_0_15px_rgba(0,255,65,0.3)]" data-id="element-115">
          ¿ESTÁS LISTO PARA JUGAR?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-inter text-xl md:text-2xl text-matrix-white max-w-3xl mb-12 font-light" data-id="element-116">
          Descubre la verdad detrás de la realidad y aprende a despertar del
          juego
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="relative mb-12" data-id="element-117">
          <div className="absolute inset-0 bg-matrix-green blur-[60px] opacity-20 rounded-full" data-id="element-118"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2PR6x8ZFYA8TBdsAuLk5o4/¿Estas_listo_para_jugar_.png" alt="Libro: ¿Estás listo para jugar?" className="relative z-10 w-64 md:w-80 lg:w-96 rounded-lg shadow-[0_0_30px_rgba(0,255,65,0.4)] animate-float border border-matrix-green/30" data-id="element-119" />
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 0 25px rgba(0,255,65,0.6)'
      }} whileTap={{
        scale: 0.95
      }} className="bg-matrix-green text-matrix-black font-inter font-bold text-xl px-10 py-4 rounded-sm uppercase tracking-wider transition-all duration-300" onClick={() => document.getElementById('precio')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-120">
          Acceder ahora
        </motion.button>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 z-10 text-matrix-green animate-bounce" data-id="element-121">
        <ChevronDown size={40} className="opacity-70" data-id="element-122" />
      </motion.div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-matrix-dark to-transparent z-0" data-id="element-123"></div>
    </section>;
}